import { WKB } from 'ol/format';
import { MultiPolygon, Polygon } from 'ol/geom';
import { GeoJsonType } from './enums';

export const geofenceToMulipartFormData = (
  geometry:
    | { type: GeoJsonType.Polygon; coordinates: number[][][] }
    | { type: GeoJsonType.Multipolygon; coordinates: number[][][][] },
  properties: Record<string, string>,
): FormData => {
  const formData = new FormData();

  const wkbFormat = new WKB({ littleEndian: true, hex: false });

  const feature =
    geometry.type === GeoJsonType.Multipolygon
      ? new MultiPolygon(geometry.coordinates)
      : new Polygon(geometry.coordinates);

  formData.append(
    'geometry',
    new Blob([wkbFormat.writeGeometry(feature)], {
      type: 'application/octet-stream',
    }),
    'geometry.wkx',
  );

  formData.append(
    'properties',
    new Blob([JSON.stringify(properties)], {
      type: 'application/json',
    }),
    'properties.json',
  );

  return formData;
};
